import React from 'react'
import { useIntl } from 'react-intl'

import { useConsentConfig } from 'components/ConsentConfigProvider'

import LazyBanner from './LazyBanner'
import LazyModal from './LazyModal'

import Locale from './locale'


export default function ConsentPrompt() {
  const consentConfig = useConsentConfig()
  const { formatMessage } = useIntl()

  const Component = ( consentConfig.display_style === 'modal' ) ? LazyModal : LazyBanner

  return (
    <Component
      ariaLabel={ formatMessage(Locale.ariaLabel) }
    />
  )
}
